<template>
  <div class="third-party-games-container">
    <div class="page-header">
      <div class="page-actions">
        <el-button type="primary" size="small" icon="el-icon-plus" @click="handleCreate">新建三方游戏</el-button>
      </div>
    </div>

    <el-table v-loading="loading" :data="games" border style="width: 100%">
      <el-table-column prop="id" label="ID" width="80" align="center" />
      <el-table-column prop="game_id" label="游戏ID" min-width="150" show-overflow-tooltip />
      <el-table-column prop="name" label="名称" min-width="180" show-overflow-tooltip />
      <el-table-column label="操作" width="150" align="center">
        <template slot-scope="scope">
          <el-button type="text" @click="handleEdit(scope.row)">编辑</el-button>
          <el-button type="text" style="color: #F56C6C" @click="handleDelete(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="460px" append-to-body>
      <el-form label-width="80px">
        <el-form-item label="游戏ID">
          <el-input v-model="form.game_id" placeholder="请输入游戏ID（英文标识）" />
        </el-form-item>
        <el-form-item label="名称">
          <el-input v-model="form.name" placeholder="请输入显示名称" />
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" :loading="saving" @click="handleSave">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getThirdPartyGames, createThirdPartyGame, updateThirdPartyGame, deleteThirdPartyGame } from "@/net/api";

export default {
  name: "ThirdPartyGames",
  data() {
    return {
      games: [],
      loading: false,
      dialogVisible: false,
      dialogTitle: "新建三方游戏",
      saving: false,
      form: {
        id: null,
        game_id: "",
        name: ""
      }
    };
  },
  created() {
    this.loadGames();
  },
  methods: {
    async loadGames() {
      this.loading = true;
      try {
        const { data } = await getThirdPartyGames();
        this.games = data || [];
      } catch (e) {
        console.error("Failed to load third party games:", e);
        this.$message.error("加载三方游戏列表失败");
      } finally {
        this.loading = false;
      }
    },
    handleCreate() {
      this.form = { id: null, game_id: "", name: "" };
      this.dialogTitle = "新建三方游戏";
      this.dialogVisible = true;
    },
    handleEdit(row) {
      this.form = { id: row.id, game_id: row.game_id, name: row.name };
      this.dialogTitle = "编辑三方游戏";
      this.dialogVisible = true;
    },
    async handleSave() {
      const gameId = (this.form.game_id || "").trim();
      const name = (this.form.name || "").trim();
      if (!gameId || !name) {
        this.$message.warning("游戏ID和名称不能为空");
        return;
      }
      this.saving = true;
      try {
        if (this.form.id) {
          await updateThirdPartyGame(this.form.id, { game_id: gameId, name });
          this.$message.success("更新成功");
        } else {
          await createThirdPartyGame({ game_id: gameId, name });
          this.$message.success("创建成功");
        }
        this.dialogVisible = false;
        await this.loadGames();
      } catch (e) {
        const msg = e.response?.data?.message || "保存失败";
        this.$message.error(msg);
      } finally {
        this.saving = false;
      }
    },
    async handleDelete(row) {
      try {
        await this.$confirm(`确定删除三方游戏「${row.name}」吗？`, "提示", { type: "warning" });
        await deleteThirdPartyGame(row.id);
        this.$message.success("删除成功");
        await this.loadGames();
      } catch (e) {
        if (e !== "cancel") {
          this.$message.error("删除失败");
        }
      }
    }
  }
};
</script>

<style scoped>
.third-party-games-container {
  padding: 16px;
}
.page-header {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 15px;
}
</style>
